import { render, staticRenderFns } from "./create-formateur.vue?vue&type=template&id=5b8d93f0&"
import script from "./create-formateur.vue?vue&type=script&lang=js&"
export * from "./create-formateur.vue?vue&type=script&lang=js&"
import style0 from "./create-formateur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports